<template>
    <nav id="Breadcrumbs">
        <router-link v-for="crumb in breadcrumbs" :to="crumb.route" :key="crumb.route" v-html="crumb.title"></router-link>
    </nav>
</template>
<script>
export default {
    name: "Breadcrumbs",
    computed: {
        breadcrumbs() {
            this.$route;
            return app.manifest.getBreadcrumbs();
        }
    }
}
</script>
<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

#Breadcrumbs {
    position: absolute;
    top: calc(100% + 40px);
    color: #000;
    width: 100%;
    max-width: var(--header-max-width);
    padding: var(--content-padding);
    pointer-events: none;
    font-size: 16px;
    z-index: 2;

    a {
        padding: 0 10px;
        pointer-events: all;
        position: relative;

        &::after {
            content: '/';
            position: absolute;
            pointer-events: none;
            margin-left: 4px;
        }

        &:last-of-type {
            cursor: default;
            color: var(--secondary-color);

            &::after {
                content: none;
            }
        }
    }

    @include mobile-only {
        display: none;
    }
}
</style>